import auditControllerHandlers from "./handlers/auditControllerHandlers";
import siteControllerHandlers from "./handlers/siteControllerHandlers";

export const handlers = [...auditControllerHandlers, ...siteControllerHandlers];
